import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { Modal } from 'antd'
import { t } from 'i18next'
import { Building } from 'models/Building'
import useSWR from 'swr'
import CommonFunction from 'utils/commonFunction'

// import Spinner from 'components/atoms/Spinner'
import CloseIcon from 'components/icons/CloseIcon'

export default function MapLocationModal({
  setOpen,
  matches
}: {
  setOpen: React.Dispatch<React.SetStateAction<boolean>>
  matches: boolean
}) {
  const { id: buildingId } = useParams()
  const { data: buildingInfo } = useSWR<Building>({
    url: `v1/buildings/${buildingId}`
  })

  const [locationUrl, setLocationUrl] = useState<string>('')

  useEffect(() => {
    const loadInitialData = async () => {
      if (buildingInfo?.extraInfo.locationUrl) {
        const locationUrl =
          await CommonFunction.FetchTourLocationContentFromS3Link(
            buildingInfo.extraInfo.locationUrl
          )

        setLocationUrl(locationUrl)
      }
    }

    loadInitialData()
  }, [buildingInfo])

  return (
    <Modal
      centered
      open
      onCancel={() => setOpen(false)}
      footer={null}
      closeIcon={
        <div className={!matches ? 'relative top-[-10px]' : ''}>
          <CloseIcon className={!matches ? 'scale-75' : ''} />
        </div>
      }
      className="business-modal"
      width={window.innerWidth * 0.8}
      destroyOnClose
    >
      <div className="flex flex-col w-full justify-center items-center p-2 gap-y-4">
        {buildingInfo?.extraInfo && (
          <iframe
            src={locationUrl?.match(/src="([^"]+)"/)?.[1] || ''}
            className="w-full h-[488px]" // Make iframe take full modal body size
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Google Map"
          />
        )}
        {window.innerWidth > 500 && (
          <div className="w-full flex justify-center items-center pt-1">
            <div
              className="underline text-center text-blue-500 cursor-pointer text-2xl"
              onClick={() => {
                window.open(
                  locationUrl?.match(/src="([^"]+)"/)?.[1] || '',
                  '_blank'
                )
              }}
            >
              {t('building.mapSetting.openMapNewTab')}
            </div>
          </div>
        )}
      </div>
    </Modal>
  )
}
